import config from '../../config';
import { createComponentStore } from '../../utils/createComponentStore';

const keyAuto = () =>
  'tfz' + (Math.floor(Math.random() * 90000000) + 10000).toString();

const initData = () => ({
  endpoint: '',
  json: '',
  type: null,
  samplePlaceholders: [{ key: keyAuto(), sampleKey: '', sampleData: '', checked: true }],
  placeholders: [],
});

const { getStore, defaultStore } = createComponentStore({
  type: 'tfz',
  endpoint: 'trigger_from_zapier',
  registryKey: 'trigger_from_zapier',
  initData,

  onLoadData: (rawData, component) => {
    if (rawData && Object.keys(rawData).length > 0) {
      return { ...rawData };
    }
    // Fallback: generate default data using componentId
    const cId = component.componentId;
    return {
      endpoint: `${config.ZAPIER_ENDPOINT.PRODUCTION}/${cId}`,
      json: '',
      type: null,
      samplePlaceholders: [{ key: keyAuto(), sampleKey: '', sampleData: '', checked: true }],
      placeholders: [],
    };
  },

  extraState: () => ({
    position: null,
    json: '',
    error: false,
    placeholderError: [],
  }),

  extraActions: (set, get) => ({
    keyAuto,

    componentData: () => {
      const { componentId } = get();
      return {
        endpoint: `${config.ZAPIER_ENDPOINT.PRODUCTION}/${componentId}`,
        json: '',
        type: null,
        samplePlaceholders: [{ key: keyAuto(), sampleKey: '', sampleData: '', checked: true }],
        placeholders: [],
      };
    },

    dataField: () => ({
      key: keyAuto(),
      sampleKey: '',
      sampleData: '',
      checked: true,
    }),

    setWebhookImportBody: (body) => set({ json: body }),

    setField: (value, index, type) => {
      const data = { ...get().data };
      switch (type) {
        case 'sample':
          data.json = value;
          break;
        case 'key':
          data[index] = { ...data[index], key: value };
          break;
        case 'type':
          data.type = value;
          data.placeholders = [];
          break;
        case 'content':
          data[index] = { ...data[index], content: value };
          break;
        default:
          break;
      }
      set({ data });
    },

    addRow: () => {
      const data = { ...get().data };
      data.samplePlaceholders = [
        ...data.samplePlaceholders,
        { key: keyAuto(), sampleKey: '', sampleData: '', checked: true },
      ];
      set({ data });
    },

    jsonData: (key, value) => ({
      key,
      sampleKey: key,
      sampleData: value,
      checked: true,
    }),

    addJsonData: (obj) => {
      const data = { ...get().data };
      data.samplePlaceholders = [...data.samplePlaceholders, obj];
      set({ data });
    },

    clearField: () => {
      const data = { ...get().data };
      data.samplePlaceholders = [];
      set({ data });
    },

    deleteRow: (placeholder) => {
      const data = { ...get().data };
      const placeholders = [...data.samplePlaceholders];
      const index = placeholders.findIndex((x) => x.key === placeholder.key);
      if (index !== -1) {
        placeholders.splice(index, 1);
        data.samplePlaceholders = placeholders;
        set({ data });
      }
    },

    onChangeField: (value, placeholder, type) => {
      const data = { ...get().data };
      const placeholders = [...data.samplePlaceholders];
      const index = placeholders.findIndex((x) => x.key === placeholder.key);
      switch (type) {
        case 'content':
          placeholders[index] = { ...placeholders[index], sampleKey: value, sampleData: '' };
          data.samplePlaceholders = placeholders;
          set({ data });
          return;
        case 'key':
          placeholders[index] = { ...placeholders[index], key: value };
          data.samplePlaceholders = placeholders;
          set({ data });
          return;
        case 'json':
          data.json = value;
          set({ data });
          return;
        default:
          break;
      }
    },

    addComponentData: () => {
      const { componentId } = get();
      const obj = {
        endpoint: `${config.ZAPIER_ENDPOINT.PRODUCTION}/${componentId}`,
        json: '',
        type: null,
        samplePlaceholders: [{ key: keyAuto(), sampleKey: '', sampleData: '', checked: true }],
        placeholders: [],
      };
      const data = [...(Array.isArray(get().data) ? get().data : [get().data]), obj];
      set({ data });
    },

    deleteComponent: (index) => {
      const data = [...get().data];
      data.splice(index, 1);
      set({ data });
    },

    storeError: (obj) => set({ placeholderError: [...obj] }),
  }),
});

export const getTriggerFromZapierStore = getStore;
export default defaultStore;
